module.exports = __webpack_public_path__ + "8c3423267a2553580bf308e383e47fb3.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/Accordion/components/Tab/images/ic_expand.svg
// module id = 1350
// module chunks = 1